import { c as _c } from "react/compiler-runtime";
import React, { type SVGProps } from 'react';
type Props = SVGProps<SVGSVGElement> & {
  backgroundColor: string;
};
export const ComparisonDecrease = React.forwardRef<SVGSVGElement, Props>((t0, ref) => {
  const $ = _c(9);
  let backgroundColor;
  let props;
  if ($[0] !== t0) {
    ({
      backgroundColor,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = backgroundColor;
    $[2] = props;
  } else {
    backgroundColor = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== backgroundColor) {
    t1 = <path d="M11.134 16.5C11.5189 17.1667 12.4811 17.1667 12.866 16.5L18.0622 7.5C18.4471 6.83333 17.966 6 17.1962 6H6.80385C6.03405 6 5.55292 6.83333 5.93782 7.5L11.134 16.5Z" fill={backgroundColor} />;
    $[3] = backgroundColor;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== ref || $[7] !== t1) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t1}</svg>;
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});